<template>
  <div class="js-system-user app-container">
    <!-- <el-button @click="adds()">
      新增
    </el-button> -->
    <app-authorize-button
      :data="authouizeList"
      :show-right-button="false"
      @click-add="adds({})"
    />

    <el-table
      v-loading="listLoading"
      ref="table"
      :data="treeData"
      row-key="functionId"
      size="mini"
      :max-height="tableHeight"
      border
      fit
      highlight-current-row
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      style="width: 100%"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      @row-click="rowClick"
    >
      <el-table-column
        prop="functionName"
        :label="$t('system.menuManager.menuName')"
      />
      <el-table-column
        prop="functionNameEn"
        :label="$t('system.menuManager.menuNameEn')"
      />
      <el-table-column
        align="center"
        prop="url"
        :label="$t('system.menuManager.link')"
      />
      <el-table-column
        align="center"
        prop="functionType"
        :label="$t('system.menuManager.menuType')"
      >
        <template slot-scope="scope">
          <span>
            {{ scope.row['functionType'] ===1 ? $t('system.menuManager.menu') : $t('system.menuManager.button') }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="sort"
        :label="$t('system.menuManager.sort')"
      />

      <el-table-column
        align="center"
        prop="isShow"
        :label="$t('system.menuManager.isShow')"
      >
        <template slot-scope="scope">
          <span>
            {{ scope.row['isShow'] ===1 ? $t('system.menuManager.show') : $t('system.menuManager.hide') }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="weight"
        :label="$t('system.menuManager.weight')"
      >
        <template slot-scope="scope">
          <span>
            {{ scope.row['weight'] | weight }}
          </span>
        </template>
      </el-table-column>
      <el-table-column width="300" :label="$t('public.operation')" align="center">
        <template slot-scope="scope">
          <div>
            <el-button size="mini" type="primary" @click="updates(scope.row)">
              <svg-icon icon-class="icon-update" />
              {{ $t('system.menuManager.update') }}
            </el-button>
          &nbsp;
            <el-button size="mini" type="primary" @click="deletes(scope.row)">
              <svg-icon icon-class="icon-delete" />
              {{ $t('system.menuManager.delete') }}
            </el-button>
         &nbsp;
            <el-button size="mini" type="primary" @click="adds(scope.row)">
              <svg-icon icon-class="icon-add" />
              {{ $t('system.menuManager.create') }}
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <add-update-dialog
      :visibles.sync="visibles"
      :is-edit="isEdit"
      :data="tableRow"
      @add-complete="addComplete"
      @update-complete="updateComplete"
    />
  </div>
</template>

<script>
import { tableStyle } from '@/mixins/tableStyle'
import { otherHeight } from '@/mixins/getOtherHeight'
import { getPageButton } from '@/mixins/getButton'

import { getAllMenu, deleteMenu } from '@/api/system/menuManager'
import addUpdateDialog from './components/addUpdateDialog'
export default {
  name: 'Menus',
  components: { addUpdateDialog },
  filters: {
    weight(val) {
      let res = ''
      switch (val) {
        case 100:
          res = vm.$t('system.menuManager.weightList.list1')
          break
        case 200:
          res = vm.$t('system.menuManager.weightList.list2')
          break
        case 300:
          res = vm.$t('system.menuManager.weightList.list3')
          break
        case 400:
          res = vm.$t('system.menuManager.weightList.list4')
          break
        case 500:
          res = vm.$t('system.menuManager.weightList.list5')
          break
        case 600:
          res = vm.$t('system.menuManager.weightList.list6')
          break
      }
      return res
    }
  },
  mixins: [tableStyle, otherHeight, getPageButton],
  data() {
    return {
      treeData: [],
      visibles: false,
      isEdit: false,
      listLoading: false,
      tableRow: {},
      selectTableRow: null,
      tableHeight: 0
    }
  },
  computed: {
    lang() {
      return this.$store.getters.language
    }
  },
  created() {
    this._getAllMenu()
    // this.authouizeList = _getNewPageButton(this.$route.name)
  },
 
  methods: {
    _getAllMenu() {
      this.listLoading = true;
      getAllMenu().then(({ data }) => {
        this.listLoading = false;
        if (data.code === 0) {
          this.treeData = data.data || {}
        }
      }).catch(() => {
        this.listLoading = false;
      })
    },
    // 进行排序
    sort(a, b) {
      return a.sort - b.sort
    },
    adds(row = {}) {
      this.isEdit = false
      this.visibles = true
      this.selectTableRow = row
      // 需根据中英文来判断

      const parentMenu = this.lang == 'zh' ? row.functionName : row.functionNameEn
      this.tableRow = { parentId: row.functionId, parentMenu: parentMenu || this.$t('system.menuManager.topLevelMenu') }
    },
    addComplete(data) {
      this.$message.success({
        message: this.$t('public.createSuccess'),
        duration: 2 * 1000
      })
      // 表明添加的父级菜单是顶层菜单
      if (!data.parentId) {
        this.treeData.push(data)
        this.treeData.sort(this.sort)
      } else {
        if (!this.selectTableRow.children) {
          this.$set(this.selectTableRow, 'children', [])
        }
        this.selectTableRow.children.push(data)
        this.selectTableRow.children.sort(this.sort)
      }
    },
    updates(row) {
      if (!row.functionId) {
        this.$alert(this.$t('public.updateTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
        return
      }
      this.isEdit = true
      this.visibles = true
      this.selectTableRow = row
      this.tableRow = row
      const functionNamesArray = this.lang == 'zh' ? row.functionNames.split('/') : row.functionNamesEn.split('/')
      const len = functionNamesArray.length
      const index = functionNamesArray.findIndex(v => v == row.functionName || v == row.functionNameEn)
      if (index > -1) {
        const parentMenu = len > 1 ? functionNamesArray[index - 1] : this.$t('system.menuManager.topLevelMenu')
        this.tableRow.parentMenu = parentMenu
      }
    },
    updateComplete(data) {
      const { parentId, functionId } = data
      this.setTreeData(this.treeData, parentId, functionId, data)
      this.$message.success({
        message: this.$t('public.updateSuccess'),
        duration: 2 * 1000
      })
    },
    // 更新
    setTreeData(treeData, parentId, functionId, updateData) {
      treeData.forEach(item => {
        if (item.functionId === parentId) {
          const index = item.children.findIndex(v => v.functionId === functionId)
          if (index > -1) {
            for (const v in updateData) {
              if (updateData[v] !== item.children[index][v]) {
                this.$set(item.children[index], v, updateData[v])
              }
            }
            item.children.sort(this.sort)
          }
        } else {
          if (item.parentId) {
            return
          }
          // 如果不存在parentId && item.functionId===parentId则说明是一级菜单
          const index = treeData.findIndex(v => v.functionId === functionId)
          if (index > -1) {
            for (const v in updateData) {
              if (updateData[v] !== this.treeData[index][v]) {
                this.$set(this.treeData[index], v, updateData[v])
              }
            }
            this.treeData.sort(this.sort)
          }
        }
        if (item.children && item.children.length > 0) {
          this.setTreeData(item.children, parentId, functionId, updateData)
        }
      })
    },
    deletes(row) {
      if (!row.functionId) {
        this.$alert(this.$t('public.deleteTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
        return
      }
      this.$confirm(this.$t('public.deleteItemTips'), this.$t('public.tips'), {
        confirmButtonText: this.$t('public.define'),
        cancelButtonText: this.$t('public.cancel'),
        type: 'warning'
      }).then(() => {
        const { functionId, parentId, ...data } = row
        const postData = { id: functionId, data }
        deleteMenu(postData).then(({ data }) => {
          if (data.code === 0) {
            this.deleteTreeData(this.treeData, parentId, functionId)
            this.$message.success({
              message: this.$t('public.deleteSuccess'),
              duration: 2 * 1000
            })
          }
        })
      })
        .catch(() => {})
    },
    // 删除
    deleteTreeData(treeData, parentId, functionId) {
      treeData.forEach(item => {
        if (item.functionId === parentId) {
          const index = item.children.findIndex(v => v.functionId === functionId)
          if (index > -1) {
            item.children.splice(index, 1)
          }
        } else {
          if (item.parentId) {
            return
          }
          // 如果不存在parentId && item.functionId===parentId则说明是一级菜单
          const index = treeData.findIndex(v => v.functionId === functionId)
          if (index > -1) {
            this.treeData.splice(index, 1)
          }
        }
        if (item.children && item.children.length > 0) {
          this.deleteTreeData(item.children, parentId, functionId)
        }
      })
    },
    rowClick(row) {
      this.tableRow = row
    }
  }
}

</script>

<style style="scss" scoped>
.action{
  cursor: pointer;
}

</style>
